import React from 'react';
import PartnerWithPilotHelper from './PartnerWithPilotHelper';

const TrainingForFlightSchools = () => {
    return (
        <div className="container pb-5" style={{ maxWidth: '800px', marginTop: '75px', paddingTop: '20px' }}>
            <h1 className="mb-4">Why Flight Schools Should Implement PilotHelper Peer Support Training</h1>

            <section className="mb-4">
                <p>
                    Flight training is one of the most demanding stages of a pilot's career. Student pilots face
                    academic pressure, financial stress, performance expectations, and the responsibility of learning
                    a safety-critical skill. Without strong support systems, these pressures can impact performance,
                    training progression, and ultimately student retention.
                </p>
            </section>

            <section className="mb-4">
                <p>
                    PilotHelper helps flight schools address these challenges by providing aviation-specific peer
                    support training for flight instructors. Instructors work closely with student pilots on a daily
                    basis, they are often the first to notice when a student may be struggling. PilotHelper equips
                    instructors with the skills to recognize early signs that a student pilot may need support and how
                    to respond with appropriate guidance.
                </p>
            </section>

            <section className="mb-4">
                <p>
                    By strengthening the instructor–student relationship, flight schools create an environment where
                    instructors are better prepared to recognize when a student pilot may need support and provide
                    guidance early. This improves communication between instructors and students, supports steady
                    training progression, and improves student retention throughout flight training.
                </p>
            </section>

            <section className="mb-4">
                <p>
                    Introducing peer support training also helps flight schools reinforce a strong safety culture. When
                    instructors are trained to recognize and respond to early warning signs, potential issues can be
                    addressed before they affect learning, decision-making, or flight performance. By implementing
                    PilotHelper's peer support training, flight schools can strengthen their training environment,
                    support student success, and build a culture of communication and safety that prepares pilots for
                    the professional aviation industry.
                </p>
            </section>

            <PartnerWithPilotHelper organizationType="flight-school" emailType="company" />
        </div>
    );
};

export default TrainingForFlightSchools;
